import { RouterState, connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import environmentReducer, { EnvironmentState } from 'store/environment'
import creditCheck, { CustomerCreditCheckState } from './creditCheck'
import { History } from 'history'

export interface RootState {
  readonly creditCheck: CustomerCreditCheckState,
  readonly environment: EnvironmentState,
  readonly router: RouterState
}

// tslint:disable-next-line:typedef no-any
export default (history: History<any>) => 
combineReducers<RootState>({
  creditCheck,
  environment: environmentReducer,
  router: connectRouter(history)
})



// WEBPACK FOOTER //
// ./src/store/rootReducer.ts